import { render } from "./MessengerPanel.vue?vue&type=template&id=07e9bcd3&scoped=true&ts=true"
import script from "./MessengerPanel.vue?vue&type=script&lang=ts"
export * from "./MessengerPanel.vue?vue&type=script&lang=ts"

import "./MessengerPanel.vue?vue&type=style&index=0&id=07e9bcd3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e9bcd3"]])

export default __exports__